import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'signin-triggers_mfa-submit';

/**
 * We want to record events whenever MFA is triggered.

- Trigger after `enterEmailView` (new flow) `"EMAIL"`
- Trigger after enter a password on `enterPasswordView`  `"ENTER_PASSWORD"`
- Trigger on confirm password on `confirmPasswordView`  `"CONFIRM_PASSWORD"`
- Trigger on logged in to SSO, but still need MFA `"SSO"`
 */
export function trackSigninTriggersMfaSubmit(
  triggerCondition: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { triggerCondition },
  });
}
